export default "__VITE_ASSET__OuSYJvi4__"